import React from 'react'

export default function ThankYou() {
  return (
    <div className="flex items-center justify-center h-screen">
        <div className='bg-black px-6 py-4 rounded-xl text-white font-black text-6xl'>
            Thank You
            <div className='text-xl font-medium text-center'>
                "Thank you for reaching here"
            </div>
        </div>
    </div>
  )
}
